webpackJsonp([59],{

/***/ "SDy6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/subscription-app-sumo-plan_8ff2c31c0cdb3f0205cee0e3a7bc0e43.html";

/***/ }),

/***/ "jKBM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
var WAVE = 0;
var SubscriptionAppSumoPlan = (function () {
    function SubscriptionAppSumoPlan() {
        this.formattedPlanName = underscore_extensions_1.Utils.getDisplayPlanName(this.planName);
    }
    SubscriptionAppSumoPlan.prototype.isHighestPlan = function () {
        return options.user.subscriptionDetails.wave.name === 'WaveBusinessAppSumo';
    };
    return SubscriptionAppSumoPlan;
}());
angular.module('animatronApp.SubscriptionAppSumoPlan', []).component('subscriptionAppSumoPlan', {
    bindings: { planName: '<' },
    controller: SubscriptionAppSumoPlan,
    templateUrl: __webpack_require__("SDy6")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/59-0e7693f8a3788edda5d0.min.js